import { createSlice } from '@reduxjs/toolkit';
import { fetchPrizes } from '../actions/prize.actions';
import { PRIZE_DEFAULT_STATE } from '../types/prize.types';

const prizeSlice = createSlice({
    name: 'prize',
    initialState: PRIZE_DEFAULT_STATE,
    reducers: {
        clearPrizesError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPrizes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPrizes.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.data = action.payload;
                state.loaded = true;
            })
            .addCase(fetchPrizes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.data = null;
            });
    }
});

export const { clearPrizesError } = prizeSlice.actions;
export const prizeReducer = prizeSlice.reducer;
